import { render, staticRenderFns } from "./LineChartB2BB2C.vue?vue&type=template&id=6d042c72&scoped=true&lang=pug&"
import script from "./LineChartB2BB2C.vue?vue&type=script&lang=ts&"
export * from "./LineChartB2BB2C.vue?vue&type=script&lang=ts&"
import style0 from "./LineChartB2BB2C.vue?vue&type=style&index=0&id=6d042c72&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d042c72",
  null
  
)

export default component.exports